// Minority / lack-of-control discount — PSD §4.2.6 (F4.4). Engine layer (framework-free).
/**
 * Compute a minority discount from control premium data.
 * Minority discount = 1 - 1/(1 + controlPremium).
 */
export function minorityDiscountFromControlPremium(controlPremium) {
    if (controlPremium <= 0)
        return 0;
    return 1 - 1 / (1 + controlPremium);
}
/**
 * Apply minority discount to a value.
 */
export function applyMinorityDiscount(value, minorityDiscount) {
    const d = Math.min(1, Math.max(0, minorityDiscount));
    return value * (1 - d);
}
//# sourceMappingURL=minorityDiscount.js.map